import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { IScrollToTop } from './interface';

const ScrollToTop: React.FC<IScrollToTop> = ({ scrollBehavior = 'auto' }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: scrollBehavior });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
